// extracted by mini-css-extract-plugin
export default {"container":"RunnerInfo_container__fYhS0","label":"RunnerInfo_label__MOCgU","runnerContainer":"RunnerInfo_runnerContainer__rlunO","long":"RunnerInfo_long__fCss4"};